import React from "react";
import { Link } from "react-router-dom";
 
    export default function Nav() {
 
    return (

        <div className="flex flex-row items-center justify-center p-0" >

                <nav id="nav-menu" className='w-full' >
                    <ul className="flex flex-col lg:flex-row">
                    <li className="p-4 border border-b-gray-200"><Link className="text-black uppercase w-full text-base font-bold text-center" to='/lucy' ><span className="text-center right-2">Shop</span></Link></li>
                    <li className="p-4 border border-b-gray-200"><Link className="text-black uppercase w-full text-base font-bold" to='/lucy' ><span className="text-center right-2">Stores</span></Link></li>
                    <li className="p-4 border border-b-gray-200"><Link className="text-black uppercase text-base font-bold" to='/lucy' ><span className="text-center right-2">Community</span></Link></li>
                    <li className="p-4 border border-b-gray-200"><Link className="text-black uppercase text-base font-bold" to='/lucy' ><span className="text-center right-2">Sustainability</span></Link></li>
                    <li className="p-4 mt-4 mx-6 pastel-link"><Link className="text-white uppercase text-base font-bold" to='/lucy' ><span className="text-center right-2">Neutral Collection</span></Link></li>
                    </ul>
                </nav>

        
        </div>
    );
}
